import { Lihe } from "@/service/CatalogApiService/catalog.types";
import { Locale } from "../translate/flights/flightTranslations.types";
import { ServiceContentResponseItem } from "../../../../requests-module/src";

export class CatalogManagerApi {

    private CATALOG_MANAGER_API_DOMAIN = 'https://api.travelski.com/catalog-manager'
    private CATALOG_MANAGER_GET_FULL_LIHE_API_URL: string = this.CATALOG_MANAGER_API_DOMAIN + '/lihe/one/:id/full?getAllImages=true'
    private locale: Locale

    constructor(locale: Locale) {
        if (locale.includes("_")) {
            locale = locale.replace("_", "-") as Locale
        }
        if (locale.toLowerCase().includes("us")) {
            locale = 'en-GB'
        }
        this.locale = locale
    }
    async getLihe(liheId: number): Promise<{
        message: {
            source?: string
            lihe: Lihe;
        }
    }> {
        const response = await fetch(this.CATALOG_MANAGER_GET_FULL_LIHE_API_URL.replace(':id', liheId.toString()), {
            method: 'GET',
            headers: {
                "accept-language": this.locale
            },
        });
        if (!response.ok) {
            throw new Error('Lihe update API call failed');
        }

        return await response.json()
    }
    async getServiceContent(
        service_ids: number[]
    ): Promise<ServiceContentResponseItem> {
        
        const queryString = `service_ids=${service_ids.toString()}&locale=${this.locale}`;
        const url = `${this.CATALOG_MANAGER_API_DOMAIN}/services/info?${queryString}`;
        
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                "Accept-Language": this.locale,
                "Accept": "application/json, text/plain, */*"
            },
        });

        if (!response.ok) {
            throw new Error('Failed to fetch service content');
        }

        const data = await response.json();
        return new ServiceContentResponseItem(data);
    }


}

